const initialState = {
  isFetching: false,
  isFetched: false,
  isUnavailable: false,
  error: null,
  changelogUrl: '',
  versions: []
};

export default initialState;
